import { CardListOneConfigBase } from '@/views/game/components/gameCardSuit2/cardList/listOne'
import { HomeLayoutType } from '@/api/common/type'
import { gameHelper } from '@/views/game/services'

/** 首页的默认布局 */
export class _ListLayoutHome extends CardListOneConfigBase {
  protected initPC(): this {
    this.width = 1136
    this.rowCardCount = 8
    this.leftRightSpacing = 48
    this.topBotSpacing = 30
    return this
  }
  protected initH5(): this {
    const topLayout = gameHelper.h5HomeLayoutStyle
    const funMapper = {
      [HomeLayoutType.style0]: () => {
        this.width = 500
        this.rowCardCount = 3
        this.leftRightSpacing = 56
        this.topBotSpacing = 44
      },
      [HomeLayoutType.style1]: () => {
        this.width = 690
        this.rowCardCount = 4
        this.leftRightSpacing = 56
        this.topBotSpacing = 44
      }
    }
    funMapper[topLayout]?.()
    return this
  }
}
